import { useState } from 'react';
import { Dialog, DialogActions } from '../ui/Dialog';
import { Button } from '../ui/Button';
import { deleteItems } from '../db/items';

/**
 * The selection's version of `DeleteItemDialog`. Separate because it can't
 * name what it's deleting, and a confirmation that can't name the thing has to
 * be more explicit about the photos instead — they're the part that exists
 * nowhere else.
 */
export function DeleteItemsDialog({
  itemIds,
  onClose,
  onDeleted,
}: {
  itemIds: readonly string[];
  onClose: () => void;
  onDeleted: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  async function confirm() {
    setBusy(true);
    setError(undefined);
    try {
      await deleteItems(itemIds);
      onDeleted();
    } catch {
      setError("Those items couldn't be deleted. Nothing was removed.");
      setBusy(false);
    }
  }

  const count = itemIds.length;

  return (
    <Dialog title={`Delete ${count} ${count === 1 ? 'item' : 'items'}?`} onClose={onClose}>
      <p>
        Their photos go too, and for anything saved from a listing that has since gone, this is the
        only copy. This can&rsquo;t be undone.
      </p>

      {error !== undefined && (
        <p className="dialog__error" role="alert">
          {error}
        </p>
      )}

      <DialogActions>
        <Button variant="quiet" onClick={onClose} disabled={busy}>
          Keep Them
        </Button>
        <Button variant="destructive" onClick={() => void confirm()} disabled={busy}>
          Delete {count === 1 ? 'It' : 'Them'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
